// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__47N0R","label":"Completed_label__2sxmg"};